<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_boiler_timer"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    ></flash-message>
    <div>
      <time-table-per-hour
        v-if="weeklyTimingsData"
        :timings-data="weeklyTimingsData"
        @swapItems="swapItems(...arguments)"
        @selectAllTimeTableData="selectAllTimeTableData"
        @clearAllTimeTableData="clearAllTimeTableData"
        @copyMondayTimeTableData="copyMondayTimeTableData"
        @saveTimeTableData="saveTimeTableData"
      />
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import { translate } from "../common/HelperFunctions";
import { weeklyTimings } from "../common/TimeTableData";
import TimeTablePerHour from "../components/TimeTablePerHour";

const fieldKeys = ["n08","n09","n10","n11","n12","n13","n14","n15","n16","n17","n18","n19"];

export default {
  components: {
    Header,
    FlashMessage,
    TimeTablePerHour
  },
  data: () => ({
    userMenuData: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    pageRefreshTime: 30,
    timerKey: 0,
    timings: undefined,
    weeklyTimingsData: weeklyTimings
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenuData = await GlobalService.getMenuData(
        "cleaning",
        this.getUser.token
      );
      this.timings = this.userMenuData["cleaning.timings"].val;
      await this.initTimingData();
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    swapItems(dayId, hourId) {
      this.weeklyTimingsData.days[dayId].hours[hourId].value =
        this.weeklyTimingsData.days[dayId].hours[hourId].value === 0 ? 1 : 0;
    },
    async initTimingData() {
      let bitData = [];
      let index = 0;
      let dayIndex = 0;
      let hourIndex = 0;

      for (let k=0; k < fieldKeys.length; k++) {
        if (this.timings.hasOwnProperty(fieldKeys[k])) {
          let value = this.timings[fieldKeys[k]];
          let current = parseInt(value);
          let result = [];

          for (let i = 0; i < 14; i++) {
            // iterate through 7 bits then increment the hour that is being processed
            if (index === 7) {
              hourIndex++;
              index = 0;
            }
            if (dayIndex === 7) {
              dayIndex = 0;
            }

            // set the current bit and place it in its day/hour
            result[i] = (current >> i) & 1; // jshint ignore:line
            this.weeklyTimingsData.days[dayIndex].hours[hourIndex].value =
              result[i];

            // increment
            dayIndex++;
            index++;
          }

          bitData.push.apply(bitData, result);
        }
      }
    },
    async encode() {
      let str = "{";
      let fields = fieldKeys;
      let flatArray = [];

      // create a flat array of the timing data
      for (let key in this.weeklyTimingsData.days) {
        let day = this.weeklyTimingsData.days[key];

        for (let hourKey in day.hours) {
          let hour = day.hours[hourKey];
          flatArray.push(parseInt(hour.value));
        }
      }

      let index = 0;
      let i = 0;
      let index2 = 0;
      let count = 0;
      let dataSize = 12;
      let ordered = [];
      let compressedTime = 0;
      let encoded = [];
      let tempArray = [];

      // Order the bits so that they are in week day order (a full days time sequentially)
      while (i < 168) {
        ordered[index] = flatArray[i];

        index += dataSize;
        i++;

        if (index > 167) {
          count++;
          index = count;
        }
      }

      count = 0;
      index = 0;
      dataSize = 14; // The size of each data set which will be encoded into a 16 bit int

      // Pick out the bits in the correct order
      // Where the order is the first time of each day and then continuing from there through each time
      for (i = 0; i <= 168; i++) {
        // deal with re-setting and shifting the index when one data set is complete
        if (index > 167) {
          count++;
          index = count;
          compressedTime = 0;
        }

        // Once a data set is complete, encode it as an int and add it to the final array
        if (index2 === dataSize) {
          // Calculate the int
          for (let a = tempArray.length - 1; a >= 0; a--) {
            compressedTime = compressedTime << 1; // jshint ignore:line
            compressedTime = compressedTime | tempArray[a]; // jshint ignore:line
          }
          encoded.push(compressedTime);

          // reset
          tempArray = [];
          index2 = 0;
        }

        // Add the current found bit to the temp array
        tempArray.push(flatArray[index]);
        index += 24;
        index2++;
      }

      // Create the data string
      for (i = 0; i < fields.length; i++) {
        if (i > 0 && i < fields.length) {
          str += ",";
        }
        str += '"' + fields[i] + '":';
        str += encoded[i];
      }
      str += "}";

      return str;
    },
    async saveTimeTableData() {
      let encodedData = await this.encode();
      let response;
      try {
        response = await GlobalService.saveFieldData(
          "cleaning",
          "cleaning.timings",
          this.getUser.token,
          encodedData
        );
      } catch (e) {
        let resObj = { status: 1, message: "Try again later" };
        this.setResponseAlert(resObj);
      }
      this.setResponseAlert(response);
    },
    selectAllTimeTableData() {
      // this.weeklyTimingsData= weeklyTimings;
      this.weeklyTimingsData.days.forEach(day => {
        day.hours.forEach(hour => {
          hour.value = 0;
        });
      });
    },
    clearAllTimeTableData() {
      // this.weeklyTimingsData= weeklyTimings;
      this.weeklyTimingsData.days.forEach(day => {
        day.hours.forEach(hour => {
          hour.value = 1;
        });
      });
    },
    copyMondayTimeTableData() {
      for (let i = 1; i < this.weeklyTimingsData.days.length; i++) {
        for (
          let hour = 0;
          hour < this.weeklyTimingsData.days[i].hours.length;
          hour++
        ) {
          this.weeklyTimingsData.days[i].hours[
            hour
          ].value = this.weeklyTimingsData.days[0].hours[hour].value;
        }
      }
    }
  }
};
</script>
